import React from 'react'
import { useTheme } from 'styled-components'
import { Tonality } from '@dsny/dsny-component-library'
import { Delete, Add } from '@dsny/dsny-component-library/icons'
import { ConnectionOptionWrapper } from './ConnectionsDropdown.styles'
import {
  DeleteIconContainer,
  IconWrapper
} from 'containers/MyNetwork/MyNetwork.styles'
import { useTranslation } from 'react-i18next'
import { getAvatarInfo } from 'utils/avatarHelpers'

const Action = {
  Add: 'Add',
  Remove: 'Remove'
}

export const ConnectionItem = ({
  connection = {},
  onClick,
  onDeleteConnection = () => {},
  action = Action.Add,
  style = {}
}) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const onConnectionClick = () => {
    onClick?.(connection)
  }

  const handleDeleteClick = () => {
    onDeleteConnection(connection?.player_id)
  }

  const { initials, color } = getAvatarInfo(
    connection.first_name,
    connection.last_name,
    connection.email
  )

  return (
    <ConnectionOptionWrapper
      style={style}
      onClick={onConnectionClick}
      $action={action}
    >
      <Tonality.Avatar
        size="medium"
        color={color}
        children={initials}
        style={{ marginRight: 12 }}
      />

      <div className="connection-info">
        <Tonality.UIText textStyle="body" color={theme.colors.neutralW60}>
          {connection?.full_name}
        </Tonality.UIText>

        <Tonality.UIText textStyle="body" color={theme.colors.neutralW60}>
          {connection?.email}
        </Tonality.UIText>
      </div>

      <IconWrapper style={{ marginLeft: 'auto' }}>
        {action === Action.Add && (
          <DeleteIconContainer>
            <Add
              width={16}
              height={16}
              style={{ cursor: 'pointer' }}
              color={theme.colors.neutralW90}
            />
          </DeleteIconContainer>
        )}
        {action === Action.Remove && (
          <Tonality.Tooltip
            mode="dark"
            content={t('network.delete-connection')}
            containerStyles={{ padding: '4px 8px' }}
          >
            <DeleteIconContainer onClick={handleDeleteClick}>
              <Delete
                width={18}
                height={18}
                style={{ cursor: 'pointer' }}
                color={theme.colors.neutralW90}
              />
            </DeleteIconContainer>
          </Tonality.Tooltip>
        )}
      </IconWrapper>
    </ConnectionOptionWrapper>
  )
}
